import { Severty, ShowToast } from "../helper/toast";
import useRequest from "../hooks/useRequest";

export const APIServices = () => {
  const { request } = useRequest();

  const getData = (
    url,
    payload,
    setter,
    loader,
    pagger,
    pagination,
  ) => {
    loader(true);

    const params = Object.keys(payload)
      .map((param) => {
        return `${param}=${payload[param]}`;
      })
      .join("&");

    console.log(params);

    request({
      url: params.length ? url + `?` + params : url,
      method: "GET",
      onSuccess: (data) => {
        if (data.status) {
          setter(data.data ?? []);
          pagger({
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: data?.data?.total,
          });
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
        loader(false);
      },
      onError: (error) => {
        ShowToast(error.message, Severty.ERROR);
        loader(false);
      },
    });
  };

  const deleteData = (url, id, loader, refresh) => {
    loader(true);
    request({
      url: url + `/${id}`,
      method: "DELETE",
      onSuccess: (data) => {
        if (data.status) {
          refresh((x) => !x);
          ShowToast(data.message, Severty.SUCCESS);
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
        loader(false);
      },
      onError: (error) => {
        ShowToast(error.message, Severty.ERROR);
        loader(false);
      },
    });
  };

  return { getData, deleteData };
};
